import React from 'react';

const EmptyState = ({ 
  message = "No items found", 
  title,
  description,
  icon = "📋", 
  action,
  className = "" 
}) => {
  // Handle icon as either string emoji, React component, or JSX
  const renderIcon = () => {
    if (typeof icon === 'string') {
      return <div className="text-4xl mb-4">{icon}</div>;
    } else if (React.isValidElement(icon)) {
      return <div className="mb-4">{icon}</div>;
    } else if (typeof icon === 'function' || (icon && icon.$$typeof)) {
      // Handle React component
      const IconComponent = icon;
      return (
        <div className="mb-4">
          <IconComponent className="mx-auto h-12 w-12 text-gray-400" />
        </div>
      );
    }
    return <div className="text-4xl mb-4">📋</div>;
  };

  return (
    <div className={`text-center py-12 ${className}`}>
      {renderIcon()}
      {title && <h3 className="mt-2 text-sm font-medium text-gray-900">{title}</h3>}
      <p className="text-gray-500 mt-1">
        {description || message}
      </p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};

export default EmptyState;